export default {
  message: {
    "strid1": "Homepage",
    "strid2": "Tutorial",
    "strid3": "Event",
    "strid4": "Sumali Sa Amin",
    "strid5": "Discord",
    "strid6": "Creator Academy",
    "strid7": "Mga Napiling Gawa",
    "strid8": "Back",
    "strid9": "Participate Now",
    "strid10": "More Events",
    "strid11": "Personal Info",
    "strid12": "Game Server",
    "strid13": "Mangyaring ilagay ang iyong Server",
    "strid14": "Game ID",
    "strid15": "Mangyaring ilagay ang iyong game ID",
    "strid16": "Contact Info",
    "strid17": "Pumili ng Platform",
    "strid18": "Mangyaring ilagay ang iyong contact info",
    "strid19": "Mga Detalye ng Trabaho",
    "strid20": "Platform ng Pag-publish",
    "strid21": "Mangyaring ilagay ang tamang link",
    "strid22": "I-tap upang magdagdag ng bagong link",
    "strid23": "Ginamit na Wika",
    "strid24": "Select language used",
    "strid25": "English",
    "strid26": "Arabic",
    "strid27": "Spanish",
    "strid28": "Portuguese",
    "strid29": "Khmer",
    "strid30": "Burmese",
    "strid31": "Malay",
    "strid32": "Other",
    "strid33": "Kinukumpirma ko ang pagmamay-ari ng trabaho at kinikilala ko ang kasunduang ito",
    "strid34": "Isumite",
    "strid35": "Submitted!",
    "strid36": "Perks",
    "strid37": "Sumali sa amin ngayon upang makakuha ng",
    "strid38": "Suporta mula sa opisyal na social media ng MLBB",
    "strid39": "Interactive na komunidad ng creator",
    "strid40": "Lingguhang Diamond na gantimpala",
    "strid41": "Higit pang perks upang i-unlock",
    "strid42": "Game Merchandise",
    "strid43": "Mga offline na event",
    "strid44": "Napakaraming mga skin",
    "strid45": "Brand collaboration",
    "strid46": "Ad promotion",
    "strid47": "SUMAlI SA AMIN",
    "strid48": "Mga Kinakailangan",
    "strid49": "I-FOLLOW KAMI",
    "strid50": "Tap to check MLBB official account",
    "strid51": "Agreement Content",
    "strid52": "Please complete the information",
    "strid53": "Submission failed",
    "strid54": "Mangyaring punan ng link ng iyong channel",  // 请输入正确的频道链接
    "strid55": "Piliin ang iyong Rehiyon",
    "strid56": "Iyong Rehiyon",

  }
}
